import React from 'react'
import { connect } from 'react-redux'

import {
  getShowConnections,
  getShowAllConnections,
  toggleConnections,
  toggleAllConnections,
} from 'ducks/settings'

import ToggleField from 'components/Shared/Forms/ToggleField'

const DisplaySettings = props => {
  const {
    showConnections,
    showAllConnections,
    toggleConnections,
    toggleAllConnections,
  } = props

  return (
    <>
      <ToggleField
        label="Do you want to see how your screens are linked?"
        helpText="Toggle this on and off at any time by pressing Shift + L"
        value={showConnections}
        inputValue="Display Screen Connections"
        onChange={toggleConnections}
      />
      {showConnections && (
        <ToggleField
          label="Show all screen connections"
          helpText="Display all screen connections at once. When off, connections are shown only for selected screens. May impact performance with many screens."
          value={showAllConnections}
          inputValue="Show All Connections"
          onChange={toggleAllConnections}
        />
      )}
    </>
  )
}

const mapStateToProps = state => ({
  showConnections: getShowConnections(state),
  showAllConnections: getShowAllConnections(state),
})

const mapDispatchToProps = {
  toggleConnections,
  toggleAllConnections,
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySettings)
